import React from "react";
import useProfileEditableState from "../../../hooks/useProfileEditableState";
import {Button} from "../../../components";

type AddTrustButtonDropdownProps = {
    onClickFn: (showModal: boolean) => void;
}

const AddFlowchartButtonDropdown: React.FC<AddTrustButtonDropdownProps> =
    ({
         onClickFn
     }) => {
        const {isProfileWithProposalsOrArchived} = useProfileEditableState();

        return (
            <Button
                className={"add-flowchart-button"}
                id="add_flowchart_button"
                size="medium"
                type="button"
                kind="primary"
                icon="left"
                iconName="add"
                disabled={isProfileWithProposalsOrArchived}
                rounded
                onClick={() => onClickFn(true)}
            >
                ADD FLOWCHART
            </Button>
        );
    };

export default AddFlowchartButtonDropdown;